<template>
  <ObDialog v-model:visible="visible" :showFoot="false" :close-on-click-overlay="false">
    <div class="label-container">
      <div class="label-top">
        <div class="label-title">
          <svg-icon v-if="media.length" @click="visible = false" name="icon-back"></svg-icon>
          <span v-if="!media.length">{{ $t('addLabel') }}</span>
          <span v-else>{{ $t('mediaLabel') }}</span>
        </div>
        <div class="label-search">
          <el-input v-model="searchLabel" @keyup.enter="entrySearch" :placeholder="$t('search')">
            <template #prefix>
              <svg-icon name="icon-search" @click.prevent.stop="entrySearch"></svg-icon>
            </template>
            <template #suffix>
              <svg-icon v-if="searchLabel.length" name="icon-clear" @click="closeSearch"></svg-icon>
            </template>
          </el-input>
          <svg-icon @click="closeLabel" class="icon-close" name="icon-close"></svg-icon>
        </div>
      </div>
      <div class="media-review" v-if="media?.length">
        <swiper :freeMode="true" :modules="modules" :centeredSlides="false" slidesPerView="auto"
        :spaceBetween="10" :lazy="true">
          <swiper-slide 
            v-for="(item, index) in media"
            :key="item.id || index"
          >
            <div class="media-item">
              <ObImg 
                v-if="item.type === 1"
                :src="item.url"
              />
              <video v-if="item.type === 2" :src="item.url"></video>
              <div class="youtube" v-if="item.type === 3">
                <svg-icon name="icon-youtube"></svg-icon>
              </div>
              <span v-if="item.type === 2 || item.type === 3">{{ $t('video') }}</span>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="label-content" v-show="!isSearch">
        <el-scrollbar :height="media?.length ? '341px' : '430px'">
          <div class="left-panel">
            <ul>
              <li @click="changeCategory(item.name, index)" :class="`${item.isActive ? 'active' : ''} ${item.name.toLowerCase().trim().split(' ').join('-')}-category`" v-for="(item, index) in labelCategory" :key="index">
                {{ index === 0 ? `${item.name} (${labelCategory[0].labels.length})` : item.name }}
              </li>
            </ul>
          </div>
        </el-scrollbar>
        <el-scrollbar ref="scrollBar" :height="media?.length ? '341px' : '430px'" :always="true">
          <div class="right-panel" :class="visible ? 'panel-active' : 'panel-hidden'">
            <div class="sync-action-wrapper" v-if="media.length">
              <el-checkbox v-model="syncLabel" :label="$t('syncLabel2Thread')"></el-checkbox>
            </div>
            <div class="panel-item" v-for="(item, index) in labelCategory" :key="index">
              <div class="title">{{ item.name }}</div>
              <div class="span-list selected-list" v-if="!index">
                <span class="active" v-for="(item, labelIndex) in item.labels" :key="labelIndex">
                  {{ item.name }}<div @click="delSelect(item)"><svg-icon name="icon-close"></svg-icon></div>
                </span>
              </div>
              <div class="span-list" v-else>
                <span @click="selectLabel(index, labelIndex, item)" :class="item.isActive ? 'active' : ''" v-for="(item, labelIndex) in item.labels" :key="labelIndex">{{ item.name }}</span>
              </div>
              <div class="position" :class="item.name.toLowerCase().replace(/ /g, '_')"></div>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <div class="search-content" v-show="isSearch" :style="{
        height: media?.length ? '341px' : '430px'
      }">
        <div class="search-arrow">
          <div @click="backToSelect">
            <svg-icon name="icon-arrow-left"></svg-icon>
            <span>{{ $t('selectedLabel') }} {{ `(${labelCategory[0].labels.length})` }}</span>
          </div>
        </div>
        <div class="span-list" v-if="searchList.length">
          <span @click="selectSearch(item, labelIndex)" :class="item.isActive ? 'active' : ''" v-for="(item, labelIndex) in searchList" :key="labelIndex">{{ item.name }}</span>
        </div>
        <div class="no-content" v-else>
          <span>{{ $t('noContent') }}</span>
        </div>
      </div>
      <div class="label-bottom">
        <el-input v-model="remark" :placeholder="$t('addRemark')">
          <template #suffix>
            <svg-icon @click="remark = ''" v-if="remark.length" class="icon-close" name="icon-close"></svg-icon>
          </template>
        </el-input>
        <el-button @click="beforeSave">{{ $t('confirm') }}</el-button>
      </div>
    </div>
  </ObDialog>
  <ObDialog 
    v-model:visible="saveConfirmVisible"
    width="464"
    :footer="true"
    @confirmCallback="save"
    @cancelCallback="onCancelSave"
  >
    <p class="confirm-text">{{$t('threadPage.confirmChangeLable')}}</p>
  </ObDialog>
</template>
<script setup>
import { ref, watch, onMounted, nextTick, getCurrentInstance, onActivated } from 'vue';
import http from '@/service';

import { Swiper, SwiperSlide } from 'swiper/vue'
import { FreeMode } from 'swiper/modules';
import 'swiper/css'
import 'swiper/css/free-mode';

const modules = [FreeMode]

const { proxy } = getCurrentInstance()
const emit = defineEmits(['update:modelValue', 'closeAll'])
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  media: {
    type: Array,
    default: []
  },
  threadInfo: {
    type: Object,
    default: () => { }
  }
})
const visible = ref(false)
const syncLabel = ref(false)
const remark = ref('')
const isSearch = ref(false)
const saveConfirmVisible = ref(false)
const searchLabel = ref('')
const searchList = ref([])
const closeLabel = () => {
  visible.value = false
  proxy.$toast({
    message: proxy.$t('labelNotSaved')
  })
  emit('closeAll')
}
const entrySearch = () => {
  searchList.value = []
  isSearch.value = true
  // 搜索
  labelCategory.value.forEach((category, index) => {
    if (index === 0) {
      return
    }
    category.labels.forEach((label) => {
      if (label.name.toLowerCase().indexOf(searchLabel.value.toLowerCase()) > -1) {
        searchList.value.push(label)
      }
    })
  })
}
const selectSearch = (item, labelIndex) => {
  // 点击分类，更新已选中列表
  if (item.isActive) {
    labelCategory.value[0].labels = labelCategory.value[0].labels.filter((label) => {
      return label.id != item.id
    })
  } else {
    labelCategory.value[0].labels.push(item)
  }
  // 点击分类，更新搜索列表选中状态
  let status = item.isActive
  searchList.value[labelIndex].isActive = !status
}
const backToSelect = () => {
  isSearch.value = false
  nextTick(() => {
    // 滚动到已选择
    labelCategory.value.forEach((item) => {
      item.isActive = false
    })
    labelCategory.value[0].isActive = true
    document.querySelector(`.${labelCategory.value[0].name.toLowerCase().replace(/ /g, '_')}`).scrollIntoView({
      block: 'start',
      behavior: 'auto'
    })
  })
}
const closeSearch = () => {
  searchLabel.value = ''
  isSearch.value = false
}
const selectedList = ref({
  
  name: proxy.$t('selectedLabel'),
  isActive: false,
  labels: []
})
const actionType = ref('add')
const labelCategory = ref([selectedList.value])
// 点击左侧标签分类
const changeCategory = (name, index) => {
  // 主动点击不触发默认的滚动事件
  stopScroll.value = true
  setTimeout(() => {
    stopScroll.value = false
  }, 500)
  labelCategory.value.forEach((item) => {
    item.isActive = false
  })
  labelCategory.value[index].isActive = true
  document.querySelector(`.panel-active .${name.toLowerCase().replace(/ /g, '_')}`).scrollIntoView({
    block: 'start',
    behavior: 'auto'
  })
}
const scrollBar = ref(null)
// 是否触发默认的滚动事件
const stopScroll = ref(false)
// 选中标签
const selectLabel = (categoryIndex, labelIndex, item) => {
  let status = labelCategory.value[categoryIndex].labels[labelIndex].isActive
  if (status) {
    // 当前状态为选中，点击后取消选中
    labelCategory.value[0].labels = labelCategory.value[0].labels.filter((label) => {
      return label.id != item.id
    })
  } else {
    // 当前状态为未选中，点击后选中
    labelCategory.value[0].labels.push({
      name: item.name,
      isActive: true,
      id: item.id
    })
  }
  labelCategory.value[categoryIndex].labels[labelIndex].isActive = !status
}
// 删除选中
const delSelect = (item) => {
  // 删除seleted中选中的
  labelCategory.value[0].labels = labelCategory.value[0].labels.filter((label) => {
    return label.id != item.id
  })
  // 删除列表中选中的
  labelCategory.value.forEach((label) => {
    label.labels.forEach((label) => {
      if (label.id === item.id) {
        label.isActive = false
      }
    })
  })
}
const beforeSave = () => {
  saveConfirmVisible.value = true
}
const onCancelSave = () => {
  saveConfirmVisible.value = false
}
const save = async () => {
  let submitData = {}
  if (actionType.value === 'add') {
    // 普通标签和媒体标签共有的参数
    submitData = {
      ...getParentIds(),
      remark: remark.value,
      labels: labelCategory.value[0].labels.map((item) => {
        return item.id
      }),
      contents: [],
      syncLabel: syncLabel.value ? 1 : 0,
    }
    // 普通标签和媒体标签的contents传参不同
    let type = 0
    // 媒体标签
    if (props.media.length) {
      props.media.forEach((item) => {
        submitData.contents.push({
          id: item.id || null,
          type: item.type === 1 ? 5 : (item.type === 2 ? 7 : 8),
          url: item.url,
        })
      })
    } else {
      // 普通标签
      let type = 0
      if (props.threadInfo.tid) {
        type = props.threadInfo.type == 1 ? 4 : 3
      } else {
        type = props.threadInfo.type === 1 ? 0 : (props.threadInfo.type === 2 ? 1 : 2)
      }
      submitData.contents = [{
        type: type,
        id: props.threadInfo.id,
        url: ''
      }]
    }
  } else {
    // 编辑
    submitData = {
      id: props.media.length ? props.media[0].id : props.threadInfo.id,
      remark: remark.value,
      labels: labelCategory.value[0].labels.map((item) => {
        return item.id
      }),
      syncLabel: syncLabel.value ? 1 : 0,
    }
  }
  // 精选Add Label需要传精选Id
  if (document.querySelector('.best-pick') && !props.media.length) {
    submitData.labels.push('9999999999')
  }
  const { code, data, msg } = await http[actionType.value === 'add' ? 'addLabel' : 'updateLabel'](submitData)
  if (code === 200) {
    
    visible.value = false
    emit('closeAll')
    saveConfirmVisible.value = false
  }
  proxy.$toast({
    message: code === 200 ? proxy.$t('threadPage.selectLable') : msg
  })
}

const getParentIds = () => {

  const info = props.threadInfo
  const isThread = info.tid == null || info.tid == undefined
  let parentThreadId = isThread? info.id : info.tid 
  let parentCommentId = null
  let parentReplyId = null
  let parentType = 1
  if (info.parentCid != null) {
    parentCommentId = info.parentCid
    parentReplyId = info.id
    parentType = 3
  } else if (!isThread) {
    parentCommentId = info.id
    parentReplyId = null
    parentType = 2
  } else {
    parentType = 1
    parentCommentId = null
    parentReplyId = null
  }

  return { parentThreadId, parentCommentId, parentReplyId, parentType }
}
// 获取所有标签
const getAllLabels = async () => {
  const { code, data, msg } = await http.getAllLabels({})
  if (code === 200 && data) {
    // 添加标签是否选中的状态 isActive
    data.forEach((item) => {
      item.isActive = false
      item.labels.forEach((item) => {
        item.isActive = false
      })
    })
    labelCategory.value = [...[selectedList.value], ...data]
  }
}
// 获取当前帖子的Label
const getThreadLabels = async (id) => {
  const { code, data, msg } = await http.getThreadLabels({
    id: id || props.threadInfo.id
  })
  actionType.value = 'add'
  if (code === 200 && data) {
    if (data?.labels?.length) {
      actionType.value = 'edit'
      labelCategory.value[0].labels = []
      // 清除所有历史选中
      labelCategory.value.forEach((item) => {
        item.isActive = false
        item.labels.forEach((item) => {
          item.isActive = false
        })
      })
      data.labels.forEach((item) => {
        labelCategory.value.forEach((category) => {
          if (item.cid === category.id) {
            category.labels.forEach((label) => {
              if (label.id === item.id) {
                label.isActive = true
                labelCategory.value[0].labels.push({
                  name: label.name,
                  isActive: true,
                  id: label.id
                })
              }
            })
          }
        })
      })
    }
  }
}
watch(() => props.modelValue, async (val) => {
  visible.value = val
  if (val) {
    // 帖子获取所有label
    if (labelCategory.value.length <= 1) {
      await getAllLabels()
      labelCategory.value[1].isActive = true
    }
    // 获取标签Label - 区分新增和编辑
    if (!props.media.length) {
      getThreadLabels()
    }
    // 获取媒体标签 - 区分新增和编辑
    if (props.media.length) {
      labelCategory.value[0].labels = []
      remark.value = ''
      // 清除所有历史选中
      labelCategory.value.forEach((item) => {
        item.isActive = false
        item.labels.forEach((item) => {
          item.isActive = false
        })
      })
      // await getThreadLabels(props.media[0].id || '0')
    }
    // 处理左右定位
    nextTick(() => {
      // 默认滚动
      labelCategory.value.forEach((item) => {
        if (item.isActive) {
          try {
            document.querySelector(`.${item.name.toLowerCase().replace(/ /g, '_')}`).scrollIntoView({
              block: 'start',
              behavior: 'auto'
            })
          } catch (error) { }
        }
      })
      // 记录labelList的高度
      let labelItemHeight = []
      document.querySelectorAll('.panel-active .panel-item').forEach((item, index) => {
        labelItemHeight.push(item.offsetHeight + (index > 0 ? labelItemHeight[index - 1] : 0))
      })
      // 监听滚动
      try {
        scrollBar.value.wrapRef.addEventListener('scroll', (val) => {
          const scrollLength = scrollBar.value.wrapRef.scrollTop
          if (stopScroll.value) {
            return
          }
          for (let i = 0; i < labelItemHeight.length; i++) {
            if (scrollLength < labelItemHeight[i]) {
              labelCategory.value.forEach((item) => {
                item.isActive = false
              })
              labelCategory.value[i].isActive = true
              document.querySelector(`.${labelCategory.value[i].name.toLowerCase().trim().split(' ').join('-')}-category`).scrollIntoView({
                block: 'center',
              })
              break;
            }
          }
        })
      } catch (error) { }
    })
  }
})
watch(() => visible.value, (val) => {
  if (!val) {
    emit('update:modelValue', val)
  }
})
onMounted(() => {
})

</script>
<style scoped lang="postcss">
.span-list {
  margin-top: 14px;

  span {
    cursor: pointer;
    padding: 4px 16px;
    border: 1px solid var(--outline);
    display: inline-block;
    font-size: 16px;
    margin-right: 8px;
    margin-bottom: 16px;
    color: rgba(0, 0, 0, 0.75);

    &.active {
      color: var(--theme) !important;
      border-color: var(--theme);
    }
  }
}

.label-container {
  width: 868px;
  height: 674px;
  background: var(--background-white);
  border-radius: 20px;

  .label-top {
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 40px;
    box-sizing: border-box;
    box-shadow: 0px 1px 0px #F5F5F5;

    .label-title {
      font-size: 28px;
      color: var(--text-primary);
      font-family: 'orbit-M';
      display: flex;
      align-items: center;

      .svg-icon {
        width: 40px;
        height: 40px;
        margin-right: 20px;
        cursor: pointer;
      }
    }

    .label-search {
      display: flex;
      align-items: center;

      .el-input {
        flex: 1;
        height: 34px;

        .svg-icon {
          width: 20px;
          height: 20px;
          color: var(--text-secondary);
        }

        :deep(.el-input__inner) {
          color: var(--text-primary);
        }
      }

      :deep(.el-input__wrapper) {
        --el-input-bg-color: var(--background-input);
        width: 350px;
        padding: 1px 15px;
        height: 34px;
        border-radius: 18px;
        box-shadow: none;
      }

      .icon-clear {
        color: rgba(0, 0, 0, 0.2) !important;
        width: 18px !important;
        height: 18px !important;
      }

      .icon-close {
        margin-left: 20px;
        width: 32px;
        height: 32px;
        color: var(--text-primary);
      }
    }
  }

  .media-review {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 40px;
    cursor: grab;
    .swiper {
      margin-left: unset;
    }
    .swiper-slide {
      width: auto;
      display: inline-block;
    }
    .media-item {
      position: relative;
      width: fit-content;
      height: 60px;
      flex-shrink: 0;
      border-radius: 4px;
      overflow: hidden;
      span {
        position: absolute;
        left: 0;
        bottom: 0;
        display: block;
        font-size: 12px;
        color: #FFF;
        padding: 0 3px;
        border-radius: 3px;
        background-color: rgba(0, 0, 0, 0.4);
      }
      video {
        aspect-ratio: 16/9;
        background-color: #000;
      }
      .ob-image, video, .youtube {
        height: 60px;
      }
      .youtube {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 78px;
        background: #ebebeb;
        .svg-icon {
          width: 60px;
          height: 60px;
        }
      }
    }
  }

  .label-content {
    box-shadow: 0px 1px 0px #F5F5F5;
    display: flex;

    .left-panel {
      width: 220px;
      border-right: 1px solid #F0F0F0;
      overflow: auto;

      li {
        text-align: left;
        cursor: pointer;
        justify-content: center;
        color: var(--text-primary);
        font-size: 14px;
        padding: 20px 40px;
        height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &.active {
          font-family: 'orbit-M';
          color: var(--theme);
        }
      }
    }

    .right-panel {
      padding: 24px 40px;
      width: 647px;
      box-sizing: border-box;

      .panel-item {
        padding-bottom: 20px;
        margin-top: 44px;
        position: relative;
        border-bottom: 1px solid #F5F5F5;

        &:first-child {
          margin-top: 0;
        }

        &:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }

        .title {
          font-size: 18px;
          color: var(--text-primary);
        }

        .selected-list {
          span {
            padding-right: 40px;
            position: relative;

            div {
              width: 40px;
              height: 100%;
              position: absolute;
              right: 0px;
              top: 50%;
              transform: translateY(-50%);
              display: flex;
              align-items: center;
            }

            .svg-icon {
              color: var(--text-disabled);
              width: 16px;
              height: 16px;
              margin-left: 12px;
            }
          }
        }

        .position {
          position: absolute;
          top: -24px;
        }
      }
    }
  }

  .search-content {
    padding: 0 40px 16px 40px;
    width: 100%;
    box-shadow: 0px 1px 0px #F5F5F5;
    box-sizing: border-box;

    .search-arrow {
      border-bottom: 1px solid #F0F0F0;

      div {
        display: flex;
        align-items: center;
        height: 54px;
        width: 180px;
        cursor: pointer;

        span {
          margin-left: 10px;
          color: rgba(0, 0, 0, 0.55);
          font-size: 14px;
        }
      }
    }

    .svg-icon {
      width: 20px;
      height: 20px;
      color: rgba(0, 0, 0, 0.55);
    }

    .span-list {
      margin-top: 21px;
    }

    .no-content {
      color: var(--text-disabled);
      text-align: center;
      padding: 16px;
      font-size: 14px;
    }
  }

  .label-bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 124px;

    .el-input {
      display: inline-block;
      width: auto;
    }

    :deep(.el-input__wrapper) {
      width: 464px;
      padding: 0 16px;
      height: 52px;
      font-size: 16px;
      color: var(--text-primary);

      &.is-focus {
        box-shadow: 0 0 0 1px var(--text-primary);
      }
    }

    :deep(.el-input__inner) {
      &::placeholder {
        color: var(--text-disabled);
      }
    }

    .icon-close {
      width: 20px;
      height: 20px;
      color: #737373;
    }

    .el-button {
      width: 280px;
      height: 52px;
      color: var(--text-primary-reverse);
      font-family: 'orbit-M';
      background: var(--theme);
      border-radius: var(--button-radius);
      margin-left: 12px;
      font-size: 16px;
    }

    .el-button.is-disabled {
      background: var(--theme-disabled);
    }
  }
}

.sync-action-wrapper {
  height: 40px;
  border-bottom: solid 1px #F0F0F0;

  :deep(.el-checkbox__inner) {
    border: solid 1px #CCCCCC;
    border-radius: 50%;

    &:hover {
      border-color: #DF3F3A;
    }
  }

  :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
    background-color: #DF3F3A;
    border-color: #DF3F3A;
  }
  
}
.confirm-text {
  font-size: 18px;
  text-align: center;
  padding: 40px 40px 0;
}
</style>